export const SET_ECOMMERCE_OBJECT_BUSINESS = "SET_ECOMMERCE_OBJECT_BUSINESS";
export const SET_ECOMMERCE_OBJECT_RESIDENTIAL =
  "SET_ECOMMERCE_OBJECT_RESIDENTIAL";
